import React, { FC, useContext, useEffect, useState } from 'react'
import './UserNameForm.scss'
import {
  ALIGN_BUTTONS_AND_LINKS,
  FORGOT_LINKS_LAYOUT,
  SHOW_FORGOT_PASSWORD_LINK,
  SHOW_FORGOT_USERNAME_LINK,
} from '~utils/featureFlags'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { Button, Form, FormInput, Link } from '@connectcore/connect-components-react'
import { LOGIN_FAILURE_SCD_ERROR, LOGIN_FORM_HEADER } from '~utils/constants'
import { useHistory } from 'react-router-dom'
import { CallbackType } from '@forgerock/javascript-sdk'

const UserNameForm: FC = () => {
  const [data, setData] = useState({ userName: null })
  const [apiError, setApiError] = useState(false)
  const { step, nextStep, showErr, storeToken, setStep, setIsLoading } = useContext(
    UserContext
  ) as IUserContextType
  const history = useHistory()
  let userNameCallBackFn

  const linksStyle =
    SHOW_FORGOT_USERNAME_LINK && SHOW_FORGOT_PASSWORD_LINK ? FORGOT_LINKS_LAYOUT : ''

  if (step?.getCallbacksOfType(CallbackType.NameCallback)?.length > 0)
    userNameCallBackFn = step?.getCallbackOfType(CallbackType.NameCallback)

  useEffect(() => {
    setApiError(showErr)
  }, [showErr])
  const submitUserNamePassword = () => {
    userNameCallBackFn?.setInputValue(data.userName)
    nextStep(step)
  }

  return (
    <Form
      className="UserNameForm"
      data-testid="UserNameForm"
      onChange={e => {
        setData({ ...data, ...e })
        setApiError(false)
      }}
      onSubmit={() => submitUserNamePassword()}
      key="UserNamePasswordForm"
    >
      <h2 className="my-5 fw-bold">{LOGIN_FORM_HEADER}</h2>

      <FormInput className="my-5" name="userName" required={true} label="Username" />

      {apiError && (
        <p className="invalid-feedback" role="alert">
          {LOGIN_FAILURE_SCD_ERROR}
        </p>
      )}

      <div className="d-flex flex-column">
        <Button kind="primary" className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}>
          Next
        </Button>

        <div className="forgot-links">
          <br />
          {SHOW_FORGOT_USERNAME_LINK && (
            <Link
              href="#"
              className={`my-3 ${linksStyle}`}
              onClick={eve2 => {
                eve2.preventDefault()
                setIsLoading(true)
                setStep(undefined)
                history.push({
                  pathname: '/forgotUsername',
                  state: { storeToken: storeToken },
                })
              }}
            >
              Forgot Username
            </Link>
          )}
        </div>
      </div>
    </Form>
  )
}

export default UserNameForm
